import SiteHeader from '../../components/SiteHeader';
import withBender from '../../hocs/withBender';

export default withBender((SiteHeader));
